import React from 'react'

interface Input {
    name: string;
    value: string | number;
    label: string;
    onChange: any;
    placeholder: string;
    id: string;
    showErrors: boolean;
    errors: Array<any>;
}
const inputClass = 'shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
export default function Input({
    name,
    label,
    value,
    onChange,
    placeholder,
    id,
    showErrors = false,
    errors,
    ...props
}: Input) {
    return (
        <>
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={name}>
                {label}
            </label>
            <input
                className={`${inputClass} ${(errors && !!errors.length && showErrors) && 'border-red-500'}`}
                id={id}
                name={name}
                type="text"
                value={value}
                placeholder={placeholder}
                onChange={onChange}
                {...props}
            />
            {(errors && !!errors.length && showErrors) && <p className="text-red-500 text-xs italic">{errors[0].message}</p>}
        </>
    )
}
